module.exports = __webpack_public_path__ + "static/media/SVG_create.24b83f40.svg";